import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { OffRampBridgeResidentialAddressInput } from '#src/__generated__/globalTypes.ts';
import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  CreateOffRampBridgeCustomerMutation,
  CreateOffRampBridgeCustomerMutationVariables,
} from './__generated__/useCreateOffRampBridgeCustomer.graphql.ts';

const CREATE_OFF_RAMP_BRIDGE_CUSTOMER_MUTATION = gql`
  mutation CreateOffRampBridgeCustomerMutation(
    $input: createOffRampBridgeCustomerInput!
  ) {
    createOffRampBridgeCustomer(input: $input) {
      bridgeAccount {
        id
        kycStatus
      }
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  CreateOffRampBridgeCustomerMutation,
  CreateOffRampBridgeCustomerMutationVariables
>;

type Input = {
  residentialAddress: OffRampBridgeResidentialAddressInput;
  signedAgreementId: string;
};

export const useCreateOffRampBridgeCustomer = () => {
  const [mutate] = useMutation(CREATE_OFF_RAMP_BRIDGE_CUSTOMER_MUTATION, {
    showErrorsInForm: true,
  });

  return async ({ residentialAddress, signedAgreementId }: Input) =>
    mutate({ variables: { input: { residentialAddress, signedAgreementId } } });
};
